import script from "./ReportViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportViewer.vue?vue&type=script&setup=true&lang=ts"

import "./ReportViewer.vue?vue&type=style&index=0&id=0f07ab57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f07ab57"]])

export default __exports__